import { createApp } from "vue";
import HikeListManager from "./HikeListManager.vue";
import { Modal } from "bootstrap";

const appElement = document.getElementById('hike-list-manager-app');
if (appElement) {
  const hikeListSlug = appElement.getAttribute('data-hike-list-slug') || '';

  const app = createApp(HikeListManager, {
    hikeListSlug: hikeListSlug
  });

  const vueInstance = app.mount('#hike-list-manager-app');

  // Set up button listeners after Vue app is mounted
  setTimeout(() => {
    // Add Hike button
    const addHikeButton = document.getElementById('show-add-hike-modal');
    if (addHikeButton) {
      addHikeButton.addEventListener('click', () => {
        const modalElement = document.getElementById('addHikeModal');
        if (modalElement) {
          const modal = new Modal(modalElement);
          modal.show();
        }
      });
    }

    // Edit List button
    const editButton = document.getElementById('show-edit-modal');
    if (editButton) {
      editButton.addEventListener('click', () => {
        const modalElement = document.getElementById('editHikeListModal');
        if (modalElement) {
          const modal = new Modal(modalElement);
          modal.show();
        }
      });
    }
  }, 100);
}
